import axios from 'axios'
const state = {}
import config from '@/../config'
const defaultErrorHandler = (error => Promise.reject(error.response))

const mutations = {}

const actions = {

    // LOGIN AND ME
    async LOGIN({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/auth/login', payload)
        return response.data
    },
    async GET_COMPANIES({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/auth/companies', payload)
        return response.data
    },
    async TEST_TOKEN({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + '/auth/login', payload)
        return response.data
    },

    async SEND_RECOVERY_PASSWORD_EMAIL({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/users/remember_password_email', payload)
        return response.data
    },

    async VALIDATE_CREATE_PASSWORD_HASH({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/users/validate_hash', payload)
        return response.data
    },
    async CREATE_PASSWORD({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + '/users/create_password', payload)
        return response.data
    },
    async CHANGE_PASSWORD({
        commit
    }, payload) {
        let response = await axios.put(config.apiUrl + config.versoes[0] + '/perfil/senha/', payload)
        return response.data
    },

    async ACCEPT_TOS({
        commit
    }, payload) {
        let response = await axios.patch(config.apiUrl + config.versoes[1] + '/usuarios/', payload)

        return response.data
    },

    async COMPLETE_REGISTRATION({
        commit
    }, payload) {
        let response = await axios.put(config.apiUrl + config.versoes[0] + '/profiles/' + payload.document, payload)
        return response.data
    },

    async GET_ME({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + '/profiles/me')
        return response.data
    }
}

export default {state, mutations, actions}



// WEBPACK FOOTER //
// ./src/store/modules/login.js